import * as hybridResources from './HybridResources';
import * as keycloakResources from './KeycloakResources';
import { getStrategyType } from './localStorageUtils';

let selectedResources = null;

export const getSelectedResources = () => {
  if (selectedResources) return selectedResources;

  const strategyType = getStrategyType();
  selectedResources =
    strategyType?.toLowerCase() === 'keycloak'
      ? keycloakResources
      : hybridResources;
  return selectedResources;
};
